export enum SystemOfMeasurement {
  METRIC = 'metric',
  IMPERIAL = 'imperial',
  US_CUSTOMARY = 'us_customary'
}
